(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ig4"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.section-{{ section.id }}.ig4c');
    if (!section) return;

    var viewport = section.querySelector('.ig4c__viewport');
    var track = section.querySelector('.ig4c__track');
    var prev = section.querySelector('.ig4c__nav--prev');
    var next = section.querySelector('.ig4c__nav--next');

    function slideWidth() {
      var first = track.querySelector('.ig4c__slide');
      if (!first) return viewport.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function scrollBySlides(dir) {
      viewport.scrollBy({ left: dir * slideWidth(), behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { scrollBySlides(-1); });
    next.addEventListener('click', function () { scrollBySlides(1); });

    // Load Instagram embed script once + process embeds
    if (window.__igEmbedScriptLoaded) {
      if (window.instgrm && window.instgrm.Embeds && window.instgrm.Embeds.process) {
        window.instgrm.Embeds.process();
      }
      return;
    }

    window.__igEmbedScriptLoaded = true;
    var s = document.createElement('script');
    s.async = true;
    s.defer = true;
    s.src = 'https://www.instagram.com/embed.js';
    s.onload = function () {
      if (window.instgrm && window.instgrm.Embeds && window.instgrm.Embeds.process) {
        window.instgrm.Embeds.process();
      }
    };
    document.body.appendChild(s);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
